import { SVGProps } from 'react';

const CursorClickedIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width || '18'}
      height={props?.height || '18'}
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_7313_12550)">
        <path
          d="M3.82524 12.2028L2.12016 13.9079C1.57184 14.4562 1.57184 15.3452 2.12016 15.8935C2.66847 16.4418 3.55748 16.4418 4.1058 15.8935L5.81088 14.1884L6.78789 16.4507C6.8582 16.6133 6.95877 16.7611 7.08425 16.8863C7.63257 17.4346 8.52157 17.4346 9.06989 16.8863C9.24985 16.7069 9.37749 16.4818 9.43909 16.2353L11.4247 8.29281C11.5404 7.83007 11.4174 7.31994 11.0555 6.95812C10.6937 6.59629 10.1836 6.47323 9.72085 6.58892L1.77827 8.5746C1.53176 8.63621 1.30671 8.76385 1.12732 8.94379C0.579 9.49211 0.579 10.3811 1.12732 10.9294C1.25247 11.0549 1.40029 11.1554 1.56292 11.2258L3.82524 12.2028Z"
          stroke={props?.fill || '#616161'}
          strokeWidth="1.29"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25354 4.81918C6.90913 2.44479 9.08477 0.701172 11.6677 0.701172C14.7695 0.701172 17.2839 3.21562 17.2839 6.31737C17.2839 8.88026 15.5672 11.0422 13.221 11.716"
          stroke={props?.fill || '#616161'}
          strokeWidth="1.29"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.96585 4.0856C10.4384 3.72448 11.0285 3.50977 11.6677 3.50977C13.2157 3.50977 14.4758 4.76916 14.4758 6.31787C14.4758 6.93716 14.2743 7.51022 13.9335 7.97496"
          stroke={props?.fill || '#616161'}
          strokeWidth="1.29"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7313_12550">
          <rect width={props?.width || '18'} height={props?.height || '18'} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CursorClickedIcon;
